/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('ProfsListCtrl', function($scope, $routeParams, Activity) {
    $scope.profs          = [];
    $scope.assets         = [];
    $scope.profs_collapse = false;
    $scope.asset_collapse = false;

    return $scope.profs_list
    .then(function(profs_list) {
        $scope.profs  = [];
        $scope.assets = [];
        return (() => {
            const result = [];
            for (let item of Array.from(profs_list)) {
                if (['prof', 'chef'].includes(item.status)) { $scope.profs.push(item); }
                if (item.status === 'asset') { result.push($scope.assets.push(item)); } else {
                    result.push(undefined);
                }
            }
            return result;
        })();
    });
});
